import { mutatorAction } from 'satcheljs';
import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';

export const setTypeOfItemBeingDragged = mutatorAction(
    'setTypeOfItemBeingDragged',
    function setTypeOfItemBeingDragged(formId: string, dataItemType: string) {
        getFullComposeViewState(formId).typeOfItemBeingDragged = dataItemType;
    }
);

export const setShowDropHint = mutatorAction(
    'setShowDropHint',
    (formId: string, shouldShow: boolean) => {
        getFullComposeViewState(formId).showDropHint = shouldShow;
    }
);
